<template>
    <div v-if="show && url">
        <clazy-load
            class="lazy-load"
            :src="url">
            <transition name="fade">
                <img class="cursor-pointer"
                    loading="lazy"
                    :src="url"
                    @click.stop="onPreviewLegend(url)">
            </transition>
            <transition name="fade" slot="placeholder">
                <div class="preloader">
                <div class="circle">
                    <div class="circle-inner"></div>
                </div>
                </div>
            </transition>
        </clazy-load>
        <VueEasyLightbox
            :visible="photos.visible"
            :index="photos.index"
            :imgs="photos.imgs"
            :moveDisabled="false"
            @hide="onClosePreviewLegend"
          />
    </div>
</template>

<script>
import { VueClazyLoad } from 'vue-clazy-load';

export default {
    name: "LayerLegendComponent",
    mixins: [
    ],
    components: {
        VueEasyLightbox: () => import(/* webpackChunkName: "vue-easy-lightbox" */ 'vue-easy-lightbox'),
        ClazyLoad: VueClazyLoad,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        url: {
            type: [String, null],
            required: false,
            default: null,
            validator: (p) => {
                return ['string'].indexOf(typeof p) !== -1 || p === null;
            },
        },
    },
    data () {
        return {
            photos: {
                imgs: [],
                visible: false,
                index: 0
            },
        }
    },
    mounted () {

    },
    computed: {

    },
    methods: {
        onShowLegend(flag) {
            if(flag) {
                this.$emit('show');
            }
        },
        onPreviewLegend(img) {
            this.photos.imgs = [img]
            this.photos.index = 0;
            this.photos.visible = true;
        },
        onClosePreviewLegend() {
            this.photos.visible = false;
        },
    },
    watch: {
        show: {
            immediate: true,
            handler: function(value) {
                this.onShowLegend(value);
            }
        }
    }
};

</script>

<style lang="scss" scoped>

</style>